import { ReactPlayerErrorBoundaryRetry } from "@package/ui-apollo-components";
import { useWallProvider } from "@package/ui-wall";
import { get } from "lodash";
import { useMemo } from "react";
import { type PostProps } from "../../utils/post-props";

export function PostVideoUrl({ asset, position, screen }: PostProps) {
  const provider = useWallProvider();

  const videoUrl = useMemo(() => get(asset, "customData.video.url"), [asset]);

  return (
    <div className="relative h-full w-full">
      <ReactPlayerErrorBoundaryRetry
        width="100%"
        height="100%"
        loop={true}
        muted
        playing
        pip={false}
        url={videoUrl}
        onEnded={() => {
          provider?.onPostRequestChange(screen.id, position);
        }}
        onErrorEvent={(error) => {
          provider?.onPostRequestChange(screen.id, position);
          console.error("[VideoUrl]: Video player error:", error);
        }}
        onMediaStalled={() => {
          provider?.onPostRequestChange(screen.id, position);
          console.error("[VideoUrl]: Video player stalled, completing video.");
        }}
      />
      <div className="absolute top-0 left-0 w-full h-full" />
    </div>
  );
}
